import { render, staticRenderFns } from "./form-city.vue?vue&type=template&id=3b2cf0fb&scoped=true"
import script from "./form-city.vue?vue&type=script&lang=js"
export * from "./form-city.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cf0fb",
  null
  
)

export default component.exports